<template>
  <v-container fluid>
    <v-card class="px-6 pb-0">
      <v-row>
        <v-col md="4" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @change="onDateChange()"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" offset-md="2">
          <v-text-field
            hide-details
            label="Find a user"
            prepend-icon="mdi-magnify"
            single-line
            v-model="search.keyword"
            @keyup.enter="fetchRegularSummary()"
          ></v-text-field>
        </v-col>
        <v-col md="3" class="mt-4">
          <v-btn block outlined color="primary">
            <v-icon>mdi-download</v-icon>
            <download-excel
              :data="daily_activity"
              worksheet="Daily"
              name="Daily Activity Report.xls"
              >Download Report</download-excel
            >
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <v-col class="pt-0" md="6">
        <GmapMap
          class="mt-3"
          :center="mapCenter"
          :zoom="zoomLevel"
          map-type-id="terrain"
          style="height: 100%"
        >
          <GmapCluster>
            <GmapMarker
              v-for="m in activities"
              :key="m.type + m.time + m.user_name"
              :position="{ lat: m.latitude, lng: m.longitude }"
              :clickable="true"
              @click="toggleInfo(m, m.user_name + m.time)"
            />
            <GmapInfoWindow
              :options="info_options"
              :position="info_position"
              :opened="info_opened"
              @closeclick="info_opened = false"
              >{{ info_content }}</GmapInfoWindow
            >
          </GmapCluster>
        </GmapMap>
      </v-col>
      <v-col md="6">
        <v-row>
          <v-col md="6">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    <v-icon medium color="success">mdi-location-enter</v-icon>
                    {{ checked_in }} / {{ total_employees }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="success--text"
                    >Checked In</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col md="6">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    <v-icon medium color="error">mdi-location-exit</v-icon>
                    {{ checked_out }} / {{ total_employees }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="error--text"
                    >Checked Out</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-card max-height="100%" class="pb-0 overflow-y-auto">
          <v-data-table
            height="auto"
            :loading="loading"
            :headers="headers"
            :items="activities"
            :server-items-length="totalData"
            :items-per-page="itemPerPage"
            :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
            :page="page"
            disable-sort
            @update:page="fetchRegularSummary($event, itemPerPage)"
            @update:items-per-page="fetchRegularSummary(page, $event)"
            :no-data-text="$t('no_data')"
            @click="focusUser(item)"
          >
           <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
            <template v-slot:item.type="{ item }">
              <v-icon v-if="item.type == 'in'" color="success"
                >mdi-location-enter</v-icon
              >
              <v-icon v-if="item.type == 'out'" color="error"
                >mdi-location-exit</v-icon
              >
            </template>
            <template v-slot:item.hours="{ item }">
              <div v-if="item.type == 'in' && item.time">
                {{ milisToHour(item.time) }}
              </div>
              <div v-if="item.type == 'out' && item.time">
                {{ milisToHour(item.time) }}
              </div>
            </template>
            <template v-slot:item.zone="{ item }">
              <div v-if="item.type == 'in'">
                {{ timezone(item.timezone) }}
              </div>
              <div v-if="item.type == 'out'">
                {{ timezone(item.timezone) }}
              </div>
            </template>
            <template v-slot:item.username="{ item }">
              <div v-if="item.type == 'in'">
                {{ item.user_name }}
              </div>
              <div v-if="item.type == 'out'">
                {{ item.user_name }}
              </div>
            </template>
          </v-data-table>
          <!-- <v-skeleton-loader
            class="mx-auto"
            type="table-tbody"
            v-if="loading"
          ></v-skeleton-loader> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from "moment";
import axios from "axios";
import mt from "moment-timezone";
export default {
  name: "activity",
  data() {
    return {
      headers: [
        { text: "Type", value: "type" },
        { text: "Full Name", value: "username" },
        { text: "Time", value: "hours" },
        { text: "Timezone", value: "zone" },
      ],
      baseUrl: this.$store.state.baseUrl,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      info_marker: null,
      info_position: null,
      info_content: null,
      info_opened: false,
      info_current_key: null,
      info_options: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      window_open: false,
      activities: [],
      daily_activity: [],
      loading: true,
      mapCenter: { lat: -6.266202, lng: 106.818325 },
      zoomLevel: 12,
      checked_in: 0,
      checked_out: 0,
      total_employees: 0,
      company_id: this.$store.state.company,
      userId: this.$store.state.user.id,
      page: 1,
      itemPerPage: 10,
      totalData: 0,
      date_search: moment().format("DD-MM-YYYY"),
      search: { keyword: "" },
    };
  },
  computed: {
    dateFormatted() {
      return this.date ? moment(this.date).format("dddd, MMMM Do YYYY") : "";
    },
  },
  methods: {
    focusUser(user) {
      this.mapCenter = {
        lat: parseFloat(user.latitude),
        lng: parseFloat(user.longitude),
      };
      this.zoomLevel = 18;
      this.toggleInfo(user, user.user_name + user.time);
    },
    milisToHour(milis) {
      return moment(milis, "x").format("HH:mm:ss");
    },
    timezone(item) {
      if (item == 7) {
        return "WIB";
      } else if (item == 8) {
        return "WITA";
      } else if (item == 9) {
        return "WIT";
      }
    },
    onDateChange() {
      this.menu = false;
      this.date_search = moment(this.date, "YYYY-MM-DD").format("DD-MM-YYYY");
      this.fetchRegularSummary();
    },
    toggleInfo(marker, key) {
      this.info_position = { lat: marker.latitude, lng: marker.longitude };
      this.info_content =
        this.toHours(marker.group_timezone, marker.time) +
        " " +
        marker.user_name +
        " (" +
        marker.type +
        ")";
      if (this.info_current_key == key) {
        this.info_opened = !this.info_opened;
      } else {
        this.info_opened = true;
        this.info_current_key = key;
      }
    },
    convertDate(time) {
      let convert = time.toString().split(" ");
      let hour = convert[4];
      return hour;
    },
    toHours(zone, time) {
      let utc = new Date(time).toUTCString();
      let tmp = "";
      if (zone === 7) {
        tmp = mt.tz(utc, "Asia/Jakarta");
      } else if (zone === 8) {
        tmp = mt.tz(utc, "Asia/Makassar");
      } else if (zone === 9) {
        tmp = mt.tz(utc, "Asia/Jayapura");
      }
      return this.convertDate(tmp);
    },
    fetchTotalEmployees() {
      const company_id = this.$store.state.company;
      const url = `${
        this.baseUrl
      }/user/countbycompanyid?companyId=${company_id}`;
      axios.get(url, {action: 'Get User by Company ID', actionId: 4}).then((res) => {
        this.total_employees = res.data.data;
      });
    },
    fetchRegularSummary(page = 1, itemPerPage = 25) {
      this.loading = true;
      this.page = page;
      this.itemPerPage = itemPerPage;
      const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
      const start = this.page;

      let url = `${this.baseUrl}/summary/getsummarydailyregular?companyId=${
        this.company_id
      }&date=${
        this.date_search
      }&page=${start}&pageSize=${totalPageSend}&userId=${this.userId}`;
      if (this.search.keyword.length > 0) {
        url = url + `&userName=${this.search.keyword}`;
      }
      axios
        .get(url, { headers: { action: 'Get Summary Daily', actionId: 4 } })
        .then((res) => {
          this.checked_in = 0;
          this.checked_out = 0;
          this.totalData = res.data.data.total;
          this.activities = [];
          this.daily_activity = [];
          res.data.data.records.forEach((vm) => {
            if (vm.type == "in") {
              this.checked_in += 1;
            }
            if (vm.type == "out") {
              this.checked_out += 1;
            }
            this.activities.push(vm);
          });
          res.data.data.records.forEach((doc) => {
            let activity = {};
            activity.EmployeeCode = doc.employee_code;
            activity.Group = doc.group_id;
            activity.FullName = doc.user_name;
            activity.CheckIn = this.toHours(
              doc.group_timezone,
              doc.time
            );
            activity.GroupTimezone = this.timezone(
              doc.group_timezone
            );
            if (doc.type == "in") {
              this.daily_activity.push(activity);
            }
          });
          this.loading = false;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err); // TODO: Add error toast message
          this.loading = false;
        });
    },
  },
  created() {
    this.fetchTotalEmployees();
    this.fetchRegularSummary();
  },
};
</script>
<style>
#google-map {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  z-index: 0;
}
#card {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
}
</style>
